import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractFascia} from "../../abstract-fascia";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-pill-fascia",
    styleUrls: ["./pill-fascia.component.scss"],
    templateUrl: "./pill-fascia.component.html"
})
export class FUIPillFasciaComponent extends FUIAbstractFascia {

}
